import React from 'react';
import { motion } from 'framer-motion';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  const toggle = () => setTheme(isDark ? 'light' : 'dark');

  return (
    <motion.button
      onClick={toggle}
      whileTap={{ scale: 0.95 }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: 50,
        height: 26,
        borderRadius: 999,
        background: isDark ? 'rgba(108,99,255,0.15)' : 'rgba(91,82,232,0.10)',
        border: '1px solid var(--border-color)',
        cursor: 'pointer',
        padding: '2px',
        flexShrink: 0,
        transition: 'background 0.3s ease, border-color 0.3s ease',
      }}
    >
      {/* Moon — always purple, brighter when active */}
      <FiMoon
        size={13}
        style={{
          position: 'absolute',
          left: 6,
          color: isDark ? '#6c63ff' : 'rgba(108,99,255,0.35)',
          transition: 'color 0.3s ease',
          pointerEvents: 'none',
        }}
      />

      {/* Sun — always amber, brighter when active */}
      <FiSun
        size={13}
        style={{
          position: 'absolute',
          right: 6,
          color: isDark ? 'rgba(251,191,36,0.35)' : '#f59e0b',
          transition: 'color 0.3s ease',
          pointerEvents: 'none',
        }}
      />

      {/* Sliding knob */}
      <motion.div
        animate={{ x: isDark ? 0 : 24 }}
        transition={{ type: 'spring', stiffness: 500, damping: 35 }}
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: isDark
            ? 'linear-gradient(135deg, #6c63ff, #9b8fff)'
            : 'linear-gradient(135deg, #f59e0b, #fbbf24)',
          boxShadow: isDark
            ? '0 1px 4px rgba(108,99,255,0.5)'
            : '0 1px 4px rgba(245,158,11,0.5)',
          flexShrink: 0,
          transition: 'background 0.3s ease, box-shadow 0.3s ease',
        }}
      />
    </motion.button>
  );
}
